import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, first } from 'rxjs/operators';

import { forkJoin, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HunspellService {
  private hunspellFactory$: ReplaySubject<any>;

  constructor(private http: HttpClient) {}

  newHunspell(langageCode): Observable<any> {
    if (!this.hunspellFactory$) {
      this.initHunspellFactory();
    }
    return forkJoin([this.hunspellFactory$.pipe(first()), this.getDicAndAffData(langageCode)]).pipe(
      map(([hunspellFactory, dicAndAff]) => hunspellFactory.create(dicAndAff.aff, dicAndAff.dic))
    );
  }

  private getDicAndAffData(languageCode): Observable<DicAndAffData> {
    const urlPrefix = `ajs-assets/dictionaries/${languageCode}`;
    const getDic$ = this.http.get(`${urlPrefix}.dic`, { responseType: 'arraybuffer' });
    const getAff$ = this.http.get(`${urlPrefix}.aff`, { responseType: 'arraybuffer' });
    return forkJoin([getDic$, getAff$]).pipe(
      map(([dic, aff]) => ({
        dic: new Uint8Array(dic),
        aff: new Uint8Array(aff),
      }))
    );
  }

  // We load hunspell.js the old way, to avoid the angular build wasting time minifying and sourcemapping it,
  // and also to speed up slightly the startup time of the app
  // (even if the js is cached, the round trip for the 304 response will use up a connexion from the pool for 50ms,
  //  and the parsing of the script takes 150ms on a fast computer)
  private initHunspellFactory() {
    this.hunspellFactory$ = new ReplaySubject();
    if ((window as any).HunspellFactory) {
      console.warn('hunspell already loaded, this is not expected');
    } else {
      const script = document.createElement('script');
      script.src = 'assets/js/hunspell.js';
      script.addEventListener('load', () => {
        this.hunspellFactory$.next((window as any).HunspellFactory);
      });
      document.body.appendChild(script);
    }
  }
}

interface DicAndAffData {
  dic: Uint8Array;
  aff: Uint8Array;
}
